import { render } from "./Profile.vue?vue&type=template&id=2cd5c6f1&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=2cd5c6f1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cd5c6f1"

export default script